import { type NodeViewComponentProps } from "@handlewithcare/react-prosemirror";
import dynamic from "next/dynamic";
import { forwardRef } from "react";

const TldrawEmbed = dynamic(() => import("./TldrawEmbed").then((mod) => mod.TldrawEmbed), {
	ssr: false,
});

/**
 * Dynamically loads the TldrawEmbed component to avoid eagerly loading
 * the tldraw rendering library which is fairly heavyweight.
 */
export const TldrawEmbedWrapper = forwardRef<HTMLDivElement | null, NodeViewComponentProps>(
	function TldrawEmbedWrapper(props, ref) {
		return (
			<div ref={ref} data-text-cell={props.nodeProps.node.attrs["id"]}>
				<TldrawEmbed {...props} />
			</div>
		);
	}
);
